import { render, staticRenderFns } from "./DynamicSettings.vue?vue&type=template&id=18a139b1"
import script from "./DynamicSettings.vue?vue&type=script&lang=js"
export * from "./DynamicSettings.vue?vue&type=script&lang=js"
import style0 from "./DynamicSettings.vue?vue&type=style&index=0&id=18a139b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports